module.exports = __webpack_public_path__ + "img/sable_bac_sable.a7628472.jpg";